// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3iqc4","colCheckbox":"styles_colCheckbox__1HXCy"};